import { render, staticRenderFns } from "./FundCitation.vue?vue&type=template&id=15c92d1d&scoped=true"
import script from "./FundCitation.vue?vue&type=script&lang=js"
export * from "./FundCitation.vue?vue&type=script&lang=js"
import style0 from "./FundCitation.vue?vue&type=style&index=0&id=15c92d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c92d1d",
  null
  
)

export default component.exports